import { Logo } from 'src/shared/components'
import dynamic from 'next/dynamic'
import { getPortalName } from '../utilities'
import { useEffect, useRef, useState } from 'react'
import { useRouter } from 'next/router'
import { Toast } from 'primereact/toast'
import { getToastInfo } from 'src/shared/stores'
import { useSelector } from 'react-redux'
import css from 'styled-jsx/css'
import { Callout } from 'com-ui2/components/Callout'
import useTrans from '../hook/useTrans'
import Link from 'next/link'
import { SmartAvatar } from 'com-ui2/components/avatar/SmartAvatar'
import { Button } from 'com-ui2/controls/Button'
import { Icon } from 'com-ui2/components/svg/Icon'
import { iconPath } from 'com-ui/utilities/imagePath'
import getConfig from 'next/config'
import { getUserInfo } from '@/shared/stores';

const SellessLayout = dynamic(() => import('com-ui2/layouts/SellessLayout'), { ssr: false })

export const AdminLayout = ({ children }: React.PropsWithChildren<any>) => {
  const router = useRouter()
  const portal = getPortalName(router.asPath)
  const info = useSelector(getUserInfo);
  const portalProps = {
    appKey: portal,
    logo: <Logo linkHref="/stream" />
  }
  const toast = useRef<any>()
  const toastInfo = useSelector(getToastInfo)

  useEffect(() => {
    console.log('toastInfo: ', toastInfo);
    if(toastInfo && toastInfo.hasOwnProperty('code')) {
      toastNoti(toastInfo)
    }

  }, [toastInfo])

  const toastNoti = (message: any) => {
    toast?.current?.show({ severity: message?.code, summary: message?.msg, life: 3000 })
  }

  return (
    <>
      <SellessLayout {...portalProps}>
        <div className="header">
          <div className="left">
          </div>
          <div className="center">
          </div>
          <div className="right">
            <Callout calloutContent={<Menu name={`${info?.['last_name']} ${info?.['first_name']}`}/>} calloutPosition="right" width="300px">
              <SmartAvatar name={`${info?.['last_name']} ${info?.['first_name']}`} size={48} />
            </Callout>
          </div>
        </div>
        {children}
        <Toast ref={toast}></Toast>

      </SellessLayout>
      <style jsx>{style}</style>
    </>
  )
}

const style = css`
  .header {
    box-shadow: var(--depth-8);
    height: 70px;
    display: flex;

    .left,
    .right,
    .center {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .center {
      flex: 1;
    }
    .left,
    .right {
      width: 70px;
      height: 70px;
    }
  }
`

interface IMenuProps {
  name?: string
}

const Menu = ({name}: IMenuProps) => {
  const trans = useTrans()
  const [logoutUrl, setLogoutUrl] = useState('')
  const info = useSelector(getUserInfo)

  useEffect(() => {
    const originUrl = window.location.origin
    const logoutUri = `${getConfig().publicRuntimeConfig.apiAdminBasePath}logout?redirect_url=${originUrl}/login`
    setLogoutUrl(logoutUri)
  }, [])

  const onClickButton = (e) => {
    e.preventDefault()
    //Clear cookie
    localStorage.clear()
    //Request logout
    window.location.href = logoutUrl
  }

  return (
    <>

      <Link href="/user/update/info">
        <div className='text-slate-500 hover:text-slate-700 flex justify-start items-center px-[20px] py-[10px]'>
          <i className="pi pi-user"></i>
          <div className='ml-[20px]'>Cập nhật thông tin</div>
        </div>
      </Link>
      <div className="my-2 px-3">
        <div className="devider"></div>
      </div>
      <Link href="/user/update/pass">
        <div className='text-slate-500 hover:text-slate-700 flex justify-start items-center px-[20px] py-[10px]'>
          <i className="pi pi-key"></i>
          <div className='ml-[20px]'>Cập nhật mật khẩu</div>
        </div>
      </Link>

      {Array.isArray(info?.roles) && info.roles.includes('tck1') && (
        <>
          <Link href="/user/order">
            <div className='text-slate-500 hover:text-slate-700 flex justify-start items-center px-[20px] py-[10px]'>
              <i className="pi pi-money-bill"></i>
              <div className='ml-[20px]'>Đăng ký gói</div>
            </div>
          </Link>
          <Link href="/user/order/detail">
            <div className='text-slate-500 hover:text-slate-700 flex justify-start items-center px-[20px] py-[10px]'>
              <i className="pi pi-info-circle"></i>
              <div className='ml-[20px]'>Thông tin chi tiết gói</div>
            </div>
          </Link>
          <Link href="/user/order/history">
            <div className='text-slate-500 hover:text-slate-700 flex justify-start items-center px-[20px] py-[10px]'>
              <i className="pi pi-book"></i>
              <div className='ml-[20px]'>Lịch sử sử dụng gói</div>
            </div>
          </Link>
        </>
      )}

      <div className="my-2 px-3">
        <div className="devider"></div>
      </div>

      <div className="mt-3 px-3">
        <Link href="/stream/campaign">
          <a className="d-flex align-items-center">
            <SmartAvatar  name={"Tuấn trịnh"} size={32} />
            <div className="ml-3 overflow-hidden">
              <div className="body-2b">{name}</div>
              <div className="text-g7">{name}</div>
            </div>
          </a>
        </Link>
      </div>

      <div className="mt-4 px-3 mb-3">
        <Button onClick={onClickButton} type="neutral" width="100%">
          <Icon src={iconPath('sign_out_regular')} fill="var(--gray-8)" className="mr-2" size="18px" />
          {trans.service.login.logout}
        </Button>
      </div>

      <style jsx>{`
        .app-item {
          display: flex;
          align-items: center;
          padding: 8px 16px;
          overflow: hidden;
          &:hover {
            background-color: var(--indigo-1);
          }
          &.disabled {
            opacity: 0.3;
            pointer-events: none;
          }
          .description {
            color: var(--indigo-7);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .text-g7 {
          color: var(--indigo-7);
        }
        .text-g8 {
          color: var(--indigo-8);
        }
      `}</style>
    </>
  )
}
